module.exports = __webpack_public_path__ + "img/pt4.fa7b6734.png";